import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaArrowRight, 
  FaTruck, 
  FaHeadset, 
  FaShieldAlt,
  FaUndo, 
  FaStar, 
  FaShoppingBag, 
  FaPhone,
  FaEnvelope,
  FaUser,
  FaGlobe,
  FaComments,
  FaMapMarkerAlt,
  FaClock,
  FaCheckCircle,
  FaHeart,
  FaEye,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaRupeeSign
} from 'react-icons/fa';

const Home = () => {
  const [currentBanner, setCurrentBanner] = useState(0);
  
  const banners = [
    {
      image: 'banner.png',
    },
    {
      image: 'banner.png',
    },
    {
      image: 'banner.png',
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    service: '',
    message: '',
    agree: false
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const countries = ['India', 'USA', 'UK', 'Canada', 'Australia', 'UAE', 'Singapore', 'Other'];
  
  const services = [
    'Furniture Consultation',
    'Interior Design',
    'Custom Furniture',
    'Home Decor',
    'Delivery Service',
    'After Sales Support'
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: '', email: '', phone: '', country: '', service: '', message: '', agree: false
      });
    }, 3000);
  };

  // ============ SECTION 1: CURTAINS ============
  const curtains = [
    {
      id: 1,
      name: 'Velvet Curtains',
      image: 'https://billionfire.com/wp-content/uploads/2025/01/image-66.png',
      color: 'Royal Blue',
      size: '7x8 ft',
      link: 'https://billionfire.com/wp-content/uploads/2025/01/image-66.png'
    },
    {
      id: 2,
      name: 'Linen Curtains',
      image: 'https://m.media-amazon.com/images/I/81h4WtEh+WL._AC_SL1500_.jpg',
      color: 'Beige',
      size: '7x8 ft',
      link: 'https://m.media-amazon.com/images/I/81h4WtEh+WL._AC_SL1500_.jpg'
    },
    {
      id: 3,
      name: 'Blackout Curtains',
      image: 'https://images.thdstatic.com/productImages/68cdd266-1248-4939-8d0d-8885393f5404/svn/black-best-home-fashion-blackout-curtains-grom-wide-80x84-black-64_1000.jpg',
      color: 'Dark Grey',
      size: '7x8 ft',
      link: 'https://images.thdstatic.com/productImages/68cdd266-1248-4939-8d0d-8885393f5404/svn/black-best-home-fashion-blackout-curtains-grom-wide-80x84-black-64_1000.jpg'
    },
    {
      id: 4,
      name: 'Sheer Curtains',
      image: 'https://cdn.shopify.com/s/files/1/0044/0031/6505/products/grey-linen-sheer-drapes-for-living-room-gray-sheer-curtains-for-sale.jpg?v=1590420495',
      color: 'White',
      size: '7x8 ft',
      link: 'https://cdn.shopify.com/s/files/1/0044/0031/6505/products/grey-linen-sheer-drapes-for-living-room-gray-sheer-curtains-for-sale.jpg?v=1590420495'
    }
  ];

  // ============ SECTION 2: BEDSHEETS ============
  const bedsheets = [
    {
      id: 1,
      name: 'Cotton Bedsheet',
      image: 'https://th.bing.com/th/id/R.0a348fcfe46078bd75473cec9abe2450?rik=OH4CJEaCXHrv6g&riu=http%3a%2f%2fcdn.shopify.com%2fs%2ffiles%2f1%2f0549%2f2532%2f8602%2fproducts%2f1_f4eb8e98-93f2-4c88-ab79-9537a727b8b1.jpg%3fv%3d1656052002&ehk=AlzOFG90qU6FnvmHIkB%2fRp0xWtjd4E0TysigjdEjGfk%3d&risl=&pid=ImgRaw&r=0',
      material: '100% Cotton',
      threadCount: '400 TC',
      link: 'https://th.bing.com/th/id/R.0a348fcfe46078bd75473cec9abe2450?rik=OH4CJEaCXHrv6g&riu=http%3a%2f%2fcdn.shopify.com%2fs%2ffiles%2f1%2f0549%2f2532%2f8602%2fproducts%2f1_f4eb8e98-93f2-4c88-ab79-9537a727b8b1.jpg%3fv%3d1656052002&ehk=AlzOFG90qU6FnvmHIkB%2fRp0xWtjd4E0TysigjdEjGfk%3d&risl=&pid=ImgRaw&r=0'
    },
    {
      id: 2,
      name: 'Silk Bedsheet',
      image: 'https://i5.walmartimages.com/seo/ANMINY-Satin-Sheets-Full-Silk-Sheets-Burgundy-Bed-Sheet-Set-Deep-Pocket-Bed-Flat-Fitted-Sheet-4-Pieces_58d7ecb2-ce62-48ab-91b4-605212a26e47.7f9545d52546cacd7a94b710cf08565a.jpeg',
      material: 'Banarasi Silk',
      threadCount: '600 TC',
      link: 'https://i5.walmartimages.com/seo/ANMINY-Satin-Sheets-Full-Silk-Sheets-Burgundy-Bed-Sheet-Set-Deep-Pocket-Bed-Flat-Fitted-Sheet-4-Pieces_58d7ecb2-ce62-48ab-91b4-605212a26e47.7f9545d52546cacd7a94b710cf08565a.jpeg'
    },
    {
      id: 3,
      name: 'Flannel Bedsheet',
      image: 'https://i5.walmartimages.com/seo/Sleepdown-4-Piece-Navy-Check-Cotton-Flannel-Bed-Sheet-Set-Queen-Deep-Pocket_98c945f1-5383-41d1-a65c-3d611850cb8b.7b2c1dbd4ea40e372a27934308a1f3d8.jpeg',
      material: 'Flannel',
      threadCount: '300 TC',
      link: 'https://i5.walmartimages.com/seo/Sleepdown-4-Piece-Navy-Check-Cotton-Flannel-Bed-Sheet-Set-Queen-Deep-Pocket_98c945f1-5383-41d1-a65c-3d611850cb8b.7b2c1dbd4ea40e372a27934308a1f3d8.jpeg'
    },
    {
      id: 4,
      name: 'Printed Bedsheet',
      image: 'https://allorabd.com/wp-content/uploads/2024/01/DSC_0402-e1704775085682.jpg',
      material: 'Cotton Blend',
      threadCount: '250 TC',
      link: 'https://allorabd.com/wp-content/uploads/2024/01/DSC_0402-e1704775085682.jpg'
    }
  ];

  // ============ SECTION 3: WALLPAPERS ============
  const wallpapers = [
    {
      id: 1,
      name: 'Floral Wallpaper',
      image: 'https://buildingandinteriors.com/wp-content/uploads/2022/06/Living-room-wallpaper-ideas_Floral-pink-wallpaper_Sanderson.webp',
      pattern: 'Floral',
      rollSize: '10m x 0.53m',
      link: 'https://buildingandinteriors.com/wp-content/uploads/2022/06/Living-room-wallpaper-ideas_Floral-pink-wallpaper_Sanderson.webp'
    },
    {
      id: 2,
      name: 'Geometric Wallpaper',
      image: 'https://tse3.mm.bing.net/th/id/OIP.9n-sb1RWZ9zh3cVUodoJeQHaEK?rs=1&pid=ImgDetMain&o=7&rm=3',
      pattern: 'Geometric',
      rollSize: '10m x 0.53m',
      link: 'https://tse3.mm.bing.net/th/id/OIP.9n-sb1RWZ9zh3cVUodoJeQHaEK?rs=1&pid=ImgDetMain&o=7&rm=3'
    },
    {
      id: 3,
      name: 'Textured Wallpaper',
      image: 'https://tse3.mm.bing.net/th/id/OIP.WlVUeuJubf3Hvfyv2IqqygHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
      pattern: 'Textured',
      rollSize: '10m x 0.53m',
      link: 'https://tse3.mm.bing.net/th/id/OIP.WlVUeuJubf3Hvfyv2IqqygHaHa?rs=1&pid=ImgDetMain&o=7&rm=3'
    },
    {
      id: 4,
      name: 'Kids Wallpaper',
      image: 'https://wallpaper.dog/large/20482536.jpg',
      pattern: 'Cartoon',
      rollSize: '10m x 0.53m',
      link: 'https://wallpaper.dog/large/20482536.jpg'
    }
  ];

  // ============ SECTION 4: MATTRESSES ============
  const mattresses = [
    {
      id: 1,
      name: 'Orthopedic Mattress',
      image: 'https://m.media-amazon.com/images/I/81HvSmy-AuL._SL1500_.jpg',
      type: 'Orthopedic',
      size: 'Queen Size',
      link: 'https://m.media-amazon.com/images/I/81HvSmy-AuL._SL1500_.jpg'
    },
    {
      id: 2,
      name: 'Memory Foam Mattress',
      image: 'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/2962da85-855f-404e-a61d-225f09acafde.jpg;maxHeight=1920;maxWidth=900?format=webp',
      type: 'Memory Foam',
      size: 'King Size',
      link: 'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/2962da85-855f-404e-a61d-225f09acafde.jpg;maxHeight=1920;maxWidth=900?format=webp'
    },
    {
      id: 3,
      name: 'Spring Mattress',
      image: 'https://i5.walmartimages.com/seo/Nisien-10-CertiPUR-US-Certified-Memory-Foam-Pocket-Spring-Mattress-Hybrid-Innerspring-Mattress-Full-Mattress-in-a-Box_e987347b-4fe0-46b8-a7b1-e44ca22e4228.97599950e86d2ba39c8380227bff7437.jpeg',
      type: 'Pocket Spring',
      size: 'Double',
      link: 'https://i5.walmartimages.com/seo/Nisien-10-CertiPUR-US-Certified-Memory-Foam-Pocket-Spring-Mattress-Hybrid-Innerspring-Mattress-Full-Mattress-in-a-Box_e987347b-4fe0-46b8-a7b1-e44ca22e4228.97599950e86d2ba39c8380227bff7437.jpeg'
    },
    {
      id: 4,
      name: 'Latex Mattress',
      image: 'https://4.imimg.com/data4/FL/BV/MY-7662291/latex-mattress-1000x1000.jpg',
      type: 'Natural Latex',
      size: 'King Size',
      link: 'https://4.imimg.com/data4/FL/BV/MY-7662291/latex-mattress-1000x1000.jpg'
    }
  ];

  // ============ SECTION 5: RUGS ============
  const rugs = [
    {
      id: 1,
      name: 'Persian Rug',
      image: 'https://st3.depositphotos.com/19132704/36209/i/1600/depositphotos_362094790-stock-photo-illustrated-persian-carpet-original-design.jpg',
      material: 'Wool',
      size: '6x9 ft',
      link: 'https://st3.depositphotos.com/19132704/36209/i/1600/depositphotos_362094790-stock-photo-illustrated-persian-carpet-original-design.jpg'
    },
    {
      id: 2,
      name: 'Modern Rug',
      image: 'https://i5.walmartimages.com/asr/b4f9b121-0171-4d97-8318-0abaa941cc58_2.b01e69962657c57f6cd3cd6802f88ab0.jpeg',
      material: 'Polyester',
      size: '5x7 ft',
      link: 'https://i5.walmartimages.com/asr/b4f9b121-0171-4d97-8318-0abaa941cc58_2.b01e69962657c57f6cd3cd6802f88ab0.jpeg'
    },
    {
      id: 3,
      name: 'Shaggy Rug',
      image: 'https://tse1.mm.bing.net/th/id/OIP.UndRrNYfUkfdNSKFEZFMUwHaKl?w=700&h=1000&rs=1&pid=ImgDetMain&o=7&rm=3',
      material: 'Acrylic',
      size: '5x8 ft',
      link: 'https://tse1.mm.bing.net/th/id/OIP.UndRrNYfUkfdNSKFEZFMUwHaKl?w=700&h=1000&rs=1&pid=ImgDetMain&o=7&rm=3'
    },
    {
      id: 4,
      name: 'Outdoor Rug',
      image: 'https://m.media-amazon.com/images/I/91sZLlInPuL._AC_SL1500_.jpg',
      material: 'Polypropylene',
      size: '6x9 ft',
      link: 'https://m.media-amazon.com/images/I/91sZLlInPuL._AC_SL1500_.jpg'
    }
  ];

  // ============ SECTION 6: DECORATIVES ============
  const decoratives = [
    {
      id: 1,
      name: 'Ceramic Vase',
      image: 'https://i.pinimg.com/736x/c4/25/f1/c425f10ccc7e7a8094636cf49fc01602.jpg',
      material: 'Ceramic',
      size: '12 inch',
      link: 'https://i.pinimg.com/736x/c4/25/f1/c425f10ccc7e7a8094636cf49fc01602.jpg'
    },
    {
      id: 2,
      name: 'Wall Art',
      image: 'https://tse1.mm.bing.net/th/id/OIP.XC5dLhppf1JShXLilMBixAHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
      material: 'Canvas',
      size: '24x36 inch',
      link: 'https://tse1.mm.bing.net/th/id/OIP.XC5dLhppf1JShXLilMBixAHaHa?rs=1&pid=ImgDetMain&o=7&rm=3'
    },
    {
      id: 3,
      name: 'Table Lamp',
      image: 'https://m.media-amazon.com/images/I/813koZli4RL.jpg',
      material: 'Metal',
      size: '18 inch',
      link: 'https://m.media-amazon.com/images/I/813koZli4RL.jpg'
    },
    {
      id: 4,
      name: 'Brass Sculpture',
      image: 'https://a.1stdibscdn.com/large-brass-seahorse-figural-sculpture-for-sale-picture-4/f_9381/f_190114921589052657793/IMG_7107_master.jpg?width=768',
      material: 'Brass',
      size: '10 inch',
      link: 'https://a.1stdibscdn.com/large-brass-seahorse-figural-sculpture-for-sale-picture-4/f_9381/f_190114921589052657793/IMG_7107_master.jpg?width=768'
    }
  ];

  // ============ CATEGORIES ============
  const categories = [
    {
      name: 'Living Room',
      image: 'https://images.pexels.com/photos/955510/pexels-photo-955510.jpeg?cs=srgb&dl=house-table-luxury-955510.jpg&fm=jpg',
      count: '245 Products',
      link: 'https://images.pexels.com/photos/955510/pexels-photo-955510.jpeg?cs=srgb&dl=house-table-luxury-955510.jpg&fm=jpg'
    },
    {
      name: 'Bedroom',
      image: 'https://cdn.pixabay.com/photo/2020/10/18/09/16/bedroom-5664221_1280.jpg',
      count: '189 Products',
      link: 'https://cdn.pixabay.com/photo/2020/10/18/09/16/bedroom-5664221_1280.jpg'
    },
    {
      name: 'Dining',
      image: 'https://tse1.mm.bing.net/th/id/OIP.0Q33mgAloK72tK3YK6kvEgHaE8?rs=1&pid=ImgDetMain&o=7&rm=3',
      count: '156 Products',
      link: 'https://tse1.mm.bing.net/th/id/OIP.0Q33mgAloK72tK3YK6kvEgHaE8?rs=1&pid=ImgDetMain&o=7&rm=3'
    },
    {
      name: 'Office',
      image: 'https://watermark.lovepik.com/photo/20211121/large/lovepik-office-office-picture_500593569.jpg',
      count: '112 Products',
      link: 'https://watermark.lovepik.com/photo/20211121/large/lovepik-office-office-picture_500593569.jpg'
    },
    {
      name: 'Lighting',
      image: 'https://www.jaquar.com/images/uploaded/10%20Creative%20Terrace%20Lighting%20Ideas/Jaquar%20-%20Pillar%20Images%20October%201.png',
      count: '203 Products',
      link: 'https://www.jaquar.com/images/uploaded/10%20Creative%20Terrace%20Lighting%20Ideas/Jaquar%20-%20Pillar%20Images%20October%201.png'
    },
    {
      name: 'Decor',
      image: 'https://tse1.mm.bing.net/th/id/OIP.skVJes6GA_vzu-vpqzxTmwHaFM?rs=1&pid=ImgDetMain&o=7&rm=3',
      count: '178 Products',
      link: 'https://tse1.mm.bing.net/th/id/OIP.skVJes6GA_vzu-vpqzxTmwHaFM?rs=1&pid=ImgDetMain&o=7&rm=3'
    }
  ];

  // ============ TESTIMONIALS ============
  const testimonials = [
    {
      name: 'Rajesh Sharma',
      role: 'Homeowner, Varanasi',
      content: 'Best furniture store in Varanasi! Great quality and beautiful designs. The Banaras collection is amazing.',
      rating: 5,
      image: 'https://randomuser.me/api/portraits/men/1.jpg'
    },
    {
      name: 'Priya Singh',
      role: 'Interior Designer',
      content: 'I recommend Home Fashion to all my clients. Their collection has something for every taste and budget.',
      rating: 5,
      image: 'https://randomuser.me/api/portraits/women/2.jpg'
    },
    {
      name: 'Amit Kumar',
      role: 'Happy Customer',
      content: 'Excellent service and delivery. The furniture quality is top-notch. Will definitely shop again.',
      rating: 5,
      image: 'https://randomuser.me/api/portraits/men/3.jpg'
    }
  ];

  // ============ OFFERS ============
  const offers = [
    {
      title: 'Summer Sale',
      discount: '50% OFF',
      code: 'SUMMER50',
      validTill: '30 June 2026'
    },
    {
      title: 'New Collection',
      discount: '30% OFF',
      code: 'NEW30',
      validTill: '15 July 2026'
    },
    {
      title: 'Free Delivery',
      discount: 'FREE SHIPPING',
      code: 'FREESHIP',
      validTill: 'Limited Time'
    }
  ];

  const ProductCard = ({ product }) => (
    <div className="group relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden">
      <a href={product.link} target="_blank" rel="noopener noreferrer" className="block relative h-48 overflow-hidden">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" />
      </a>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-gray-800 mb-1 line-clamp-1">{product.name}</h3>
        <p className="text-xs text-gray-500 mb-3 line-clamp-1">
          {product.color || product.material || product.pattern || product.type} • {product.size || product.rollSize || product.threadCount}
        </p>
        <button className="w-full py-2 text-xs bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300">
          View Details
        </button>
      </div>
    </div>
  );

  // Section Component
  const Section = ({ title, products, viewAllLink, bgColor }) => (
    <section className={`py-12 ${bgColor}`}>
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">
            <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
              {title}
            </span>
          </h2>
          <Link to={viewAllLink} className="group flex items-center gap-1 text-pink-500 font-semibold text-sm hover:gap-2 transition-all duration-300">
            View All <FaArrowRight className="group-hover:translate-x-1 transition-transform" size={12} />
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ============ BANNER SECTION - FULL WIDTH NO SPACE ============ */}
      <section className="relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] h-[250px] sm:h-[350px] md:h-[450px] lg:h-[550px] overflow-hidden">
        {banners.map((banner, index) => (
          <div
            key={index}
            className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ease-in-out ${
              index === currentBanner ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={banner.image}
              alt={`Banner ${index + 1}`}
              className="w-full h-auto object-cover object-center"
            />
          </div>
        ))}
        
        {/* Banner Navigation Dots */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentBanner(index)}
              className={`h-2 rounded-full transition-all duration-300 ${
                index === currentBanner ? 'w-8 bg-pink-500' : 'w-2 bg-white/70 hover:bg-white'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* ============ ENQUIRY FORM & ABOUT US ============ */}
      <section className="py-12 bg-gradient-to-br from-pink-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-6">
            {/* LEFT: ENQUIRY FORM */}
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold mb-4">
                <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
                  Enquiry Form
                </span>
              </h2>
              
              {formSubmitted ? (
                <div className="text-center py-8">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <FaCheckCircle className="w-8 h-8 text-green-500" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-1">Thank You!</h3>
                  <p className="text-sm text-gray-600">Your enquiry has been submitted successfully.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-1">Your Name *</label>
                    <div className="relative">
                      <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                      <input type="text" name="name" value={formData.name} onChange={handleChange} required
                        className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500"
                        placeholder="Enter your name" />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-1">Your Email id *</label>
                    <div className="relative">
                      <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                      <input type="email" name="email" value={formData.email} onChange={handleChange} required
                        className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500"
                        placeholder="Enter your email" />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-1">Number *</label>
                    <div className="relative">
                      <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required
                        className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500"
                        placeholder="Enter your phone" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-700 text-sm font-medium mb-1">Select Country</label>
                      <div className="relative">
                        <FaGlobe className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm z-10" />
                        <select name="country" value={formData.country} onChange={handleChange}
                          className="w-full pl-9 pr-6 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500 appearance-none bg-white">
                          <option value="">Select</option>
                          {countries.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                      </div>
                    </div>
                    <div>
                      <label className="block text-gray-700 text-sm font-medium mb-1">Select Services</label>
                      <div className="relative">
                        <FaComments className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm z-10" />
                        <select name="service" value={formData.service} onChange={handleChange}
                          className="w-full pl-9 pr-6 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500 appearance-none bg-white">
                          <option value="">Select</option>
                          {services.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-1">Message *</label>
                    <textarea name="message" value={formData.message} onChange={handleChange} required
                      rows="3" className="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500"
                      placeholder="Type your message..."></textarea>
                  </div>

                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                    <label className="flex items-start gap-2 cursor-pointer">
                      <input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} required
                        className="mt-0.5 w-4 h-4 text-pink-500 rounded flex-shrink-0" />
                      <span className="text-xs text-gray-700 leading-relaxed">
                        I agree to all the Terms of Services and Privacy Policy. I want to receive JDS Technology product information, promotions, and blog updates via Email, SMS, WhatsApp, and RCS messages.
                      </span>
                    </label>
                  </div>

                  <button type="submit"
                    className="w-full py-3 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg font-semibold text-sm hover:shadow-lg transform hover:scale-105 transition-all duration-300">
                    Submit Enquiry
                  </button>
                </form>
              )}
            </div>

            {/* RIGHT: ABOUT US */}
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold mb-4">
                <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
                  About Us
                </span>
              </h2>
              
              <div className="space-y-4">
                <a href="https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" target="_blank" rel="noopener noreferrer" className="relative h-40 rounded-lg overflow-hidden block">
                  <img src="https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Showroom" className="w-full h-full object-cover" />
                </a>
                
                <p className="text-sm text-gray-600 leading-relaxed">
                  Welcome to <span className="font-semibold text-pink-500">Home Fashion Varanasi</span>, serving since 2010 with premium furniture and decor.
                </p>
                
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2">
                    <FaMapMarkerAlt className="text-pink-500 text-sm" />
                    <span className="text-gray-600">Rathyatra-Mahmmoorganj Road, Varanasi</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaPhone className="text-pink-500 text-sm" />
                    <span className="text-gray-600">8573035759</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaClock className="text-pink-500 text-sm" />
                    <span className="text-gray-600">Mon-Sat: 10am - 8pm</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="text-center p-3 bg-pink-50 rounded-lg">
                    <div className="text-lg font-bold text-pink-500">500+</div>
                    <div className="text-xs text-gray-600">Products</div>
                  </div>
                  <div className="text-center p-3 bg-blue-50 rounded-lg">
                    <div className="text-lg font-bold text-blue-500">15+</div>
                    <div className="text-xs text-gray-600">Years</div>
                  </div>
                </div>

                <Link to="/about" className="inline-flex items-center gap-1 text-pink-500 text-sm font-semibold hover:gap-2 transition-all duration-300">
                  Read More <FaArrowRight size={12} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ FEATURES ============ */}
      <section className="py-10 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-6">
            <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
              Why Choose Us
            </span>
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <FaTruck className="text-pink-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold mb-1">Free Delivery</h3>
              <p className="text-xs text-gray-500">In Varanasi</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <FaHeadset className="text-blue-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold mb-1">24/7 Support</h3>
              <p className="text-xs text-gray-500">Call anytime</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <FaShieldAlt className="text-purple-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold mb-1">Secure Payment</h3>
              <p className="text-xs text-gray-500">100% secure</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <FaUndo className="text-green-500 text-lg" />
              </div>
              <h3 className="text-sm font-semibold mb-1">Easy Returns</h3>
              <p className="text-xs text-gray-500">7-day policy</p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ SECTION 1: CURTAINS ============ */}
      <Section title="Premium Curtains" products={curtains} viewAllLink="/category/curtains" bgColor="bg-white" />

      {/* ============ SECTION 2: BEDSHEETS ============ */}
      <Section title="Luxury Bedsheets" products={bedsheets} viewAllLink="/category/bedsheets" bgColor="bg-gray-50" />

      {/* ============ SECTION 3: WALLPAPERS ============ */}
      <Section title="Designer Wallpapers" products={wallpapers} viewAllLink="/category/wallpapers" bgColor="bg-white" />

      {/* ============ SECTION 4: MATTRESSES ============ */}
      <Section title="Premium Mattresses" products={mattresses} viewAllLink="/category/mattresses" bgColor="bg-gray-50" />

      {/* ============ SECTION 5: RUGS ============ */}
      <Section title="Beautiful Rugs" products={rugs} viewAllLink="/category/rugs" bgColor="bg-white" />

      {/* ============ SECTION 6: DECORATIVES ============ */}
      <Section title="Home Decoratives" products={decoratives} viewAllLink="/category/decoratives" bgColor="bg-gray-50" />

      {/* ============ CATEGORIES ============ */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-6">
            <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
              Shop by Category
            </span>
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {categories.map((cat, i) => (
              <a href={cat.link} target="_blank" rel="noopener noreferrer" key={i} className="group relative h-32 rounded-lg overflow-hidden block">
                <img src={cat.image} alt={cat.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-2 text-white">
                  <h3 className="text-xs font-semibold">{cat.name}</h3>
                  <p className="text-[10px] opacity-80">{cat.count}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ============ SPECIAL OFFERS ============ */}
      <section className="py-12 bg-gradient-to-r from-pink-500 to-blue-500">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center text-white mb-4">Special Offers</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {offers.map((offer, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-lg rounded-lg p-4 text-center text-white">
                <h3 className="text-base font-bold mb-1">{offer.title}</h3>
                <p className="text-xl font-bold mb-2 text-yellow-300">{offer.discount}</p>
                <p className="text-xs opacity-80">Code: {offer.code}</p>
                <p className="text-[10px] opacity-60">Valid till: {offer.validTill}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ TESTIMONIALS ============ */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-6">
            <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
              Customer Reviews
            </span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-gray-50 p-4 rounded-lg">
                <div className="flex items-center gap-3 mb-2">
                  <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                  <div>
                    <h4 className="text-sm font-semibold">{t.name}</h4>
                    <p className="text-xs text-gray-500">{t.role}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {[...Array(5)].map((_, idx) => (
                    <FaStar key={idx} className={idx < t.rating ? 'text-yellow-400 text-xs' : 'text-gray-300 text-xs'} />
                  ))}
                </div>
                <p className="text-xs text-gray-600">"{t.content}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ NEWSLETTER ============ */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto text-center">
            <h2 className="text-xl font-bold mb-2">
              <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
                Subscribe Now
              </span>
            </h2>
            <p className="text-xs text-gray-600 mb-4">Get updates on new products & offers</p>
            <form className="flex gap-2">
              <input type="email" placeholder="Your email" className="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-300 focus:outline-none focus:border-pink-500" />
              <button className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white text-sm rounded-lg font-semibold">Subscribe</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;